





























































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { MemberAccountListCard } from '@/@types/Member.js';
import { AccountActionList } from '@/@types/LibraryComponent.js';
import AccountDetailModal from '@/components/member/memberCommon/accountDetailModal/AccountDetailModalBase.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';

@Component({
  components: {
    AccountDetailModal,
    AccountIcon,
  },
})
export default class AccountListCard extends Vue {
  @Prop({ type: Array, required: true }) public accountList!: Array<MemberAccountListCard>;
  @Prop({ type: Array, required: true }) public accountActionList!: Array<AccountActionList>;
  private accountActionButton: boolean = false;
  private transition = 'slide-y-reverse-transition';
  private isOpenAccountDetailDrawer: boolean = false;
  private isFavorite: boolean = false;
  private isSearchBarFocus = false;

  private closeAccountDetailDrawer(): void {
    this.isOpenAccountDetailDrawer = false;
  }

  private openDrawer() {
    this.isOpenAccountDetailDrawer = !this.isOpenAccountDetailDrawer;
  }

  private starColor(): '#bdbdbd' | 'yellow darken-1' {
    if (this.isFavorite) {
      return 'yellow darken-1';
    }
    return '#bdbdbd';
  }

  private clickedActionButton(notDisabled: boolean, icon: string): void {
    const selectContent = this.accountActionList.find((x) => x.icon === icon);
    if (selectContent) {
      if (notDisabled) {
        selectContent.notDisabled = false;
      } else {
        selectContent.notDisabled = true;
      }
    }
  }

  private clickedActionButtonColor(color: string, notDisabled: boolean): string {
    if (notDisabled) {
      return 'grey lighten-1';
    } else {
      return color;
    }
  }

  private SearchBarFocusBackground(): 'white' | 'grey lighten-3' {
    if (this.isSearchBarFocus) {
      return 'white';
    }
    return 'grey lighten-3';
  }

  private SearchBarFocusFlat(): boolean {
    if (this.isSearchBarFocus) {
      return false;
    }
    return true;
  }
}
